// extracted by mini-css-extract-plugin
export default {"container":"MeasureKindSelect_container__Uewlv","element":"MeasureKindSelect_element__5W6Oi","selected":"MeasureKindSelect_selected__osToe"};